import styles from "./Realization.module.scss";
import { Link } from "react-router-dom";
export default function Realzation() {
  return (
    <>
      <div className={styles.headerTop}> Realizacja umów</div>
      <div className={styles.container}>
        <Link className={styles.logo} to="/contracts/list">
          <div className={styles.row}>
            <div className={styles.header}>Szkice umów</div>
            <div className={styles.number}>2</div>
          </div>
        </Link>
        <Link className={styles.logo} to="/contracts/list">
          <div className={styles.row}>
            <div className={styles.header}>Umowy do weryfikacji</div>
            <div className={styles.number}>13</div>
          </div>
        </Link>
        <Link className={styles.logo} to="/contracts/list">
          <div className={styles.row}>
            <div className={styles.header}>Umowy do akceptacji</div>
            <div className={styles.number}>38</div>
          </div>
        </Link>
        <Link className={styles.logo} to="/contracts/list">
          <div className={styles.row}>
            <div className={styles.header}>Umowy do poprawy</div>
            <div className={styles.number}>5</div>
          </div>
        </Link>
      </div>
    </>
  );
}
